import React from "react";

export async function GeminiAPI(patch: any): Promise<any> {
  const { GoogleGenAI } = await import("@google/genai");

  const ai = new GoogleGenAI({
    apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  });

  const prompt = `
You are a cybersecurity expert. Analyze the following vulnerable code patch.
- Identify only the vulnerable part of the code.
- Give the root cause of the vulnerability.
- Recommend a specific fix for that vulnerability.
- Do NOT rewrite unrelated code.
- Provide the recommendation in Markdown Format, have header, codeblocks, and bullet points where appropriate.

Vulnerable patch:
${patch}
`;

  const response = await ai.models.generateContent({
    model: "gemini-2.5-flash",
    contents: prompt,
    config: {
      thinkingConfig: {
        thinkingBudget: 500,
      },
    },
  });

  console.log(response.text);
  let text = response.text as string;

  console.log("Before check:", text);

  // Ensure code blocks exist
  if (!text?.includes("```")) {
    text = "```\n" + text + "\n```";
  }

  return response.text;
}
